import { GetBackofficeSupportQuestionsSchema } from "schema"
import { z } from "zod"

export const backofficeSupportFiltersCacheKey = ["backofficeSupportFilters"] as const

export type BackofficeSupportFiltersCache = {
  filterBy: z.infer<typeof GetBackofficeSupportQuestionsSchema>["filterBy"]
}
